export default "__VITE_ASSET__ZA0Zvswh__"